import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function FloatingMobileCTA() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 120) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (dismissed) return null;

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-50 transition-transform duration-300 ease-in-out ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      {/* Top accent line */}
      <div className="h-0.5 bg-gradient-to-r from-sky-500 via-sky-400 to-emerald-400" />

      <div className="bg-[#0F2340] px-4 py-3 flex items-center gap-3">
        {/* Call button — primary */}
        <a
          href="tel:+15615122820"
          className="flex-1 flex items-center justify-center gap-2 bg-sky-500 hover:bg-sky-600 active:bg-sky-700 text-white font-bold text-sm py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
          aria-label="Call ORPM"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-phone-fill text-base animate-pulse"></i>
          </div>
          +1 (561) 512-2820
        </a>

        {/* Quote button — secondary */}
        <Link
          to="/contact"
          className="flex-1 flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 active:bg-white/30 border border-white/20 text-white font-semibold text-sm py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
          aria-label="Get free quote"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-file-list-3-line text-sky-300 text-base"></i>
          </div>
          {t('nav_quote')}
        </Link>

        {/* Dismiss button */}
        <button
          onClick={() => setDismissed(true)}
          className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 hover:bg-white/15 text-slate-400 hover:text-white transition-colors cursor-pointer shrink-0"
          aria-label="Close banner"
        >
          <i className="ri-close-line text-lg"></i>
        </button>
      </div>

      {/* Safe area for phones with home indicator */}
      <div className="bg-[#0F2340] h-safe-bottom" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }} />
    </div>
  );
}
